// src/common/model/preference/model/WatermarkConfig.ts
import BaseEntity from "../../base/BaseEntity";
import Lang from '../../global/Lang';
export default class WatermarkConfig extends BaseEntity {
  // 是否启用水印
  enabled: boolean = false;

// 预览文件
text: string = Lang.t('watermark.previewFile');
// 字体大小
fontSize: number = 36;
// 字体颜色
color: string = 'rgba(128, 128, 128, 0.3)';
// 透明度
opacity: number = 0.3;
// 旋转角度
rotate: number = -30;
// 是否显示用户名
showUser: boolean = false;
// PDF文件水印文本
pdfText: string = Lang.t('watermark.pdfText');
// PDF文件水印颜色
pdfColor: string = 'rgba(255, 0, 0, 0.2)';
// 图片文件水印文本
imageText: string = Lang.t('watermark.imageText');
// 图片文件水印透明度
imageOpacity: number = 0.2;
// 文档文件水印文本
documentText: string = Lang.t('watermark.documentText');

  constructor(reactComponent?: React.Component) {
    super(reactComponent);
  }

  getForm(): any {
    return {
      enabled: this.enabled,
      text: this.text,
      fontSize: this.fontSize,
      color: this.color,
      opacity: this.opacity,
      rotate: this.rotate,
      showUser: this.showUser,
      pdfText: this.pdfText,
      pdfColor: this.pdfColor,
      imageText: this.imageText,
      imageOpacity: this.imageOpacity,
      documentText: this.documentText
    };
  }

 // 在 WatermarkConfig.ts 中
assign(obj: any): WatermarkConfig {
    super.assign(obj);
  
    this.enabled = obj.enabled !== undefined ? obj.enabled : false;
    this.text = obj.text || '预览文件';
    this.fontSize = obj.fontSize || 36;
    this.color = obj.color || 'rgba(128, 128, 128, 0.3)';
    this.opacity = obj.opacity || 0.3;
    this.rotate = obj.rotate || -30;
    this.showUser = obj.showUser !== undefined ? obj.showUser : false;
    this.pdfText = obj.pdfText || '机密文件 - 禁止外传';
    this.pdfColor = obj.pdfColor || 'rgba(255, 0, 0, 0.2)';
    this.imageText = obj.imageText || '图片预览';
    this.imageOpacity = obj.imageOpacity || 0.2;
    this.documentText = obj.documentText || '文档预览';
  
    return this;
  }
}